"use strict";
/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockFluidDataStoreContext = void 0;
const telemetry_utils_1 = require("@fluidframework/telemetry-utils");
const uuid_1 = require("uuid");
class MockFluidDataStoreContext {
    constructor(id = (0, uuid_1.v4)(), existing = false, logger = telemetry_utils_1.DebugLogger.create("fluid:MockFluidDataStoreContext")) {
        this.id = id;
        this.existing = existing;
        this.logger = logger;
        /**
         * @deprecated This field is currently unused and will be removed in an
         * upcoming breaking change
         */
        this.documentId = undefined;
        this.isLocalDataStore = true;
        this.packagePath = undefined;
        this.options = undefined;
        this.clientId = (0, uuid_1.v4)();
        this.clientDetails = undefined;
        this.connected = true;
        this.deltaManager = undefined;
        this.containerRuntime = undefined;
        this.storage = undefined;
        this.IFluidDataStoreRegistry = undefined;
        this.IFluidHandleContext = undefined;
        /**
         * Indicates the attachment state of the data store to a host service.
         */
        this.attachState = undefined;
        this.scope = undefined;
    }
    on(event, listener) {
        switch (event) {
            case "attaching":
            case "attached":
                return this;
            default:
                throw new Error("Method not implemented.");
        }
    }
    once(event, listener) {
        return this;
    }
    off(event, listener) {
        throw new Error("Method not implemented.");
    }
    getQuorum() {
        return undefined;
    }
    getAudience() {
        return undefined;
    }
    submitMessage(type, content, localOpMetadata) {
        throw new Error("Method not implemented.");
    }
    submitSignal(type, content) {
        throw new Error("Method not implemented.");
    }
    bindToContext() {
        throw new Error("Method not implemented.");
    }
    setChannelDirty(address) {
        throw new Error("Method not implemented.");
    }
    async getAbsoluteUrl(relativeUrl) {
        throw new Error("Method not implemented.");
    }
    getCreateChildSummarizerNodeFn(id, createParam) {
        throw new Error("Method not implemented.");
    }
    async uploadBlob(blob) {
        throw new Error("Method not implemented.");
    }
    async getInitialGCSummaryDetails() {
        throw new Error("Method not implemented.");
    }
    async getBaseGCDetails() {
        throw new Error("Method not implemented.");
    }
}
exports.MockFluidDataStoreContext = MockFluidDataStoreContext;
//# sourceMappingURL=mocksDataStoreContext.js.map